import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TrialStatus } from '../../core/partner/partner-trial-status';
import { PartnerTrialStoreService } from '../../partner-trial';
import { LevelBadgeStoreService } from './level-badge-store.service';

const formatRemainingTrialDays = function (remainingDays: number): string {
  return remainingDays + (remainingDays === 1 ? ' DAY REMAINING' : ' DAYS REMAINING');
};

@Component({
  selector: 'app-trial-badge',
  templateUrl: './trial-badge.component.html',
  styleUrls: ['./trial-badge.component.scss'],
  standalone: false,
})
export class TrialBadgeComponent {
  showBadge$: Observable<boolean>;
  trialActive$: Observable<boolean>;
  trialExpiringSoon$: Observable<boolean>;
  trialDaysRemaining$: Observable<string>;

  constructor(
    private trialService: PartnerTrialStoreService,
    private badgeStore: LevelBadgeStoreService,
  ) {
    this.trialActive$ = this.trialService.partnerTrial$.pipe(map((t) => t.status === TrialStatus.ACTIVE));
    this.trialExpiringSoon$ = this.trialService.partnerTrial$.pipe(map((t) => t.expiringSoon));
    this.trialDaysRemaining$ = this.trialService.partnerTrial$.pipe(
      map((t) => formatRemainingTrialDays(t.remainingDays)),
    );
    this.showBadge$ = this.badgeStore.showBadge$;
  }
}
